import { DateTime } from 'luxon';

export const isDisclaimerAvailable = (startDate?: string | null, endDate?: string | null) => {
	if (!startDate && !endDate) return true;

	const _startDate = DateTime.fromISO(startDate ?? '');
	const _endDate = DateTime.fromISO(endDate ?? '');

	// Both dates are maintained
	if (_startDate.isValid && _endDate.isValid) {
		const now = DateTime.now();
		return _startDate <= now && now <= _endDate;
	}

	// Only start date is maintained
	if (_startDate.isValid) {
		const now = DateTime.now();
		return _startDate <= now;
	}

	// Only end date is maintained
	if (_endDate.isValid) {
		const now = DateTime.now();
		return now <= _endDate;
	}

	// Fallback for unexpected stuff
	return true;
};
